<template>
  <v-dialog v-model="parent.uploadCenterDocumentsModal" max-width="600px" persistent scrollable>
    <v-card>
      <v-card-title class="text-h6 white--text px-2 py-1" :class="titleClass"
        >センター添付書類{{ `｜` + parent?.uploadingRow?.member_name_en }}</v-card-title
      >
      <v-card class="mx-4 my-1 pt-2" outlined elevation="0">
        <v-row no-gutters>
          <v-col class="d-flex pb-0" cols="12" sm="3">
            <v-card-text class="text-start text-sm-end align-self-center">
              <v-btn
                small
                color="primary darken-1"
                style="float: right"
                @click="
                  $refs.centerDocumentsRef.click();
                  $refs.centerDocumentsRef.value = '';
                "
                >ファイル追加
              </v-btn>
              <input
                type="file"
                required
                style="display: none"
                @change="centerDocuments.push($event.target.files[0])"
                ref="centerDocumentsRef"
              />
            </v-card-text>
          </v-col>
          <v-col class="d-flex pb-0" cols="12" sm="9">
            <div
              v-if="centerDocuments && centerDocuments.length > 0"
              class="align-self-center mr-2"
              style="width: 100%"
            >
              <div
                v-for="(row, index) of centerDocuments"
                :key="index"
                style="display: flex; flexdirection: row; height: 40px"
              >
                <div style="overflow: hidden; white-space: nowrap; flex-grow: 1; text-overflow: ellipsis">
                  <a v-if="row.key" @click="downloadFile({ key: row.key })" style="line-height: 35px">{{ row.name }}</a>
                  <span v-else style="line-height: 35px">{{ row.name }}</span>
                </div>
                <v-btn
                  dense
                  color="red darken-1"
                  :loading="uploadLoading"
                  @click="centerDocuments.splice(index, 1)"
                  style="float: right"
                  >削除</v-btn
                >
              </div>
            </div>
            <div v-else class="align-self-center mr-2" style="width: 100%">
              <span style="line-height: 35px">ファイルアップロードされていません。</span>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card-actions class="d-flex justify-end">
        <v-btn dense color="primary darken-1" :loading="uploadLoading" @click="register"> OK </v-btn>
        <v-btn
          dense
          color="orange darken-1"
          text
          :loading="uploadLoading"
          :disabled="uploadLoading"
          @click="parent.uploadCenterDocumentsModal = false"
        >
          cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  props: { parent: { type: Object, default: Object, required: true } },
  data() {
    return { centerDocuments: null };
  },
  methods: {
    ...mapActions({
      getAwsCredentials: 'api/getAwsCredentials',
      uploadToS3: 'api/uploadToS3',
      apiUpdatePacking: 'api/updateEachPackingInfo',
      downloadFile: 'api/downloadFile',
      encodeFileToBase64: 'common/encodeFileToBase64',
      createFileInfo: 'common/createFileInfo',
    }),

    async register() {
      const credentials = await this.getAwsCredentials({ type: 'upload-document' });
      await Promise.all(
        this.centerDocuments.map(async (row) => {
          if (row && row.name && row.size) {
            // ファイルをBase64エンコード
            const base64Data = await this.encodeFileToBase64(row);
            const fileInfo = await this.createFileInfo({ file: row, base64Data });

            const result = await this.uploadToS3({
              s3Info: credentials,
              file: fileInfo,
              keyParams: [this.parent.uploadingRow.shipping_seq_number],
            });

            row.key = result.Key;
            return Promise.resolve(row);
          } else {
            return Promise.resolve(null);
          }
        }),
      );

      /**
       * 出荷書類作成画面情報編集
       * @param $1 in_shipping_seq_number character varying,
       * @param $2 in_reservation_number character varying,
       * @param $3 in_bikou character varying,
       * @param $4 in_shipping_bikou_flag integer,
       * @param $5 in_arms_payment_received_flag integer,
       * @param $6 in_shipment_documents jsonb,
       * @param $7 in_operator_documents jsonb,
       * @param $8 in_center_documents jsonb,
       * @param $9 in_update_user_id character varying,
       * @param $10 in_shipping_data_checker character varying,
       * @param $11 in_main_shipping_data_checker character varying,
       * @param $12 in_status integer,
       * @param $13 double_check character varying,
       */
      const updates = [
        this.parent.uploadingRow.shipping_seq_number,
        null,
        null,
        null,
        null,
        null,
        null,
        this.centerDocuments.map((row) => {
          return { key: row.key, name: row.name };
        }),
        this.user ? this.user.userName : 'SYSTEM',
        null,
        null,
        null,
        null,
        null,
        null,
        null,
      ];
      await this.apiUpdatePacking(updates);
      this.parent.uploadCenterDocumentsModal = false;
    },
  },
  computed: {
    ...mapGetters({
      labels: 'defined/labels',
      error: 'ui/error',
      success: 'ui/success',
      uploadLoading: 'ui/uploadLoading',
      user: 'defined/user',
    }),
    titleClass() {
      return { red: this.error, primary: !this.error && !this.success, success: this.success };
    },
  },
  watch: {
    'parent.uploadCenterDocumentsModal'() {
      if (
        this.parent.uploadingRow.center_documents === null ||
        !Array.isArray(this.parent.uploadingRow.center_documents)
      ) {
        this.parent.uploadingRow.center_documents = [];
      }
      this.centerDocuments = this.parent.uploadingRow.center_documents;
    },
  },
};
</script>
<style scoped>
div.v-card__text {
  white-space: pre-wrap;
}
</style>
